import React, { FC } from 'react';

import { Loader } from '@crehana/ui';

import Loadable from 'Jsx/Shared/Loadable';

import { TrailerPlayerProps } from './types';

const LazyTrailerPlayer: FC<TrailerPlayerProps> = props => {
  return (
    <Loadable
      Loader={
        <div
          className="bg-gray-light relative"
          style={{ paddingTop: '56.25%' }}
        >
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader isWhite />
          </div>
        </div>
      }
      module={() =>
        import(
          /* webpackChunkName: "shared-trailer-player" */ './TrailerPlayer'
        )
      }
      {...props}
    />
  );
};

export default LazyTrailerPlayer;
